import { InputNumber, Popover, Select } from '@meitu/saas-ui';
import './grid-line-operate.less';
import { cloneDeep } from 'lodash';
import { useState } from 'react';
import IconFont from '@meitu/xdesign-icon-font';
import { DefaultGridInfo, IGridInfoProps, useStageGridStore } from '../../models/stage-grid-state';

const GridLineOperate = () => {
    const setGridInfo = useStageGridStore()((state) => state.setGridInfo);
    const originGridInfo = useStageGridStore()((state) => state.gridInfo);

    const gridInfo = originGridInfo || cloneDeep(DefaultGridInfo);
    const [presetValue, setPresetValue] = useState<string>('');
    const gridInfoChange = (info: IGridInfoProps) => {
        setGridInfo(info);
        setPresetValue('');
    };

    const Content = () => {
        return (
            <div className="c-grid-line-operate-content-wrapper">
                <div className="c-grid-line-operate-content-preset">
                    <div className="title">预设：</div>
                    <Select
                        value={presetValue}
                        style={{ width: '100%' }}
                        onChange={(value) => {
                            console.log(value);
                            setPresetValue(value);
                            if (value === '0') {
                                setGridInfo(cloneDeep(DefaultGridInfo));
                            } else if (value === '1') {
                                setGridInfo({
                                    ...DefaultGridInfo,
                                    leftRightSpace: {
                                        value: 186,
                                        visible: true,
                                    },
                                    topBottomSpace: {
                                        value: 176,
                                        visible: true,
                                    },
                                });
                            } else if (value === '2') {
                                setGridInfo({
                                    ...DefaultGridInfo,
                                    leftRightSpace: {
                                        value: 108,
                                        visible: true,
                                    },
                                    topBottomSpace: {
                                        value: 90,
                                        visible: true,
                                    },
                                });
                            } else if (value === '3') {
                                setGridInfo({
                                    ...DefaultGridInfo,
                                    innerRightSpace: {
                                        value: 108,
                                        visible: true,
                                    },
                                    innerBottomSpace: {
                                        value: 90,
                                        visible: true,
                                    },
                                    leftRightSpace: {
                                        value: 192,
                                        visible: true,
                                    },
                                    topBottomSpace: {
                                        value: 176,
                                        visible: true,
                                    },
                                });
                            }
                        }}
                    >
                        <Select.Option value="0">默认</Select.Option>
                        <Select.Option value="1">首页带框</Select.Option>
                        <Select.Option value="2">首页不带框</Select.Option>
                        <Select.Option value="3">内页</Select.Option>
                    </Select>
                    <div className={`preset-item preset-${presetValue}`}></div>
                </div>
                <div className="c-grid-line-operate-content">
                    <div className="row">
                        <div className="title">网格：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.grid.value}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        grid: {
                                            ...gridInfo.grid,
                                            value: value || 0,
                                        },
                                    });
                                }}
                            />
                        </div>
                        {gridInfo.grid.visible ? (
                            <IconFont
                                name="VisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        grid: {
                                            ...gridInfo.grid,
                                            visible: false,
                                        },
                                    });
                                }}
                            />
                        ) : (
                            <IconFont
                                name="InvisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        grid: {
                                            ...gridInfo.grid,
                                            visible: true,
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>
                    <div className="row">
                        <div className="title">行间距：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.rowSpace}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        rowSpace: value || 0,
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="title">列间距：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.columnSpace}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        columnSpace: value || 0,
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="title">行数：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.rows.value}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        rows: {
                                            ...gridInfo.rows,
                                            value: value || 0,
                                        },
                                    });
                                }}
                            />
                        </div>
                        {gridInfo.rows.visible ? (
                            <IconFont
                                name="VisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        rows: {
                                            ...gridInfo.rows,
                                            visible: false,
                                        },
                                    });
                                }}
                            />
                        ) : (
                            <IconFont
                                name="InvisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        rows: {
                                            ...gridInfo.rows,
                                            visible: true,
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>
                    <div className="row">
                        <div className="title">列数：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.columns.value}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        columns: {
                                            ...gridInfo.columns,
                                            value: value || 0,
                                        },
                                    });
                                }}
                            />
                        </div>
                        {gridInfo.columns.visible ? (
                            <IconFont
                                name="VisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        columns: {
                                            ...gridInfo.columns,
                                            visible: false,
                                        },
                                    });
                                }}
                            />
                        ) : (
                            <IconFont
                                name="InvisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        columns: {
                                            ...gridInfo.columns,
                                            visible: true,
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>

                    <div className="row">
                        <div className="title">左右间距：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.leftRightSpace.value}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        leftRightSpace: {
                                            ...gridInfo.leftRightSpace,
                                            value: value || 0,
                                        },
                                    });
                                }}
                            />
                        </div>
                        {gridInfo.leftRightSpace.visible ? (
                            <IconFont
                                name="VisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        leftRightSpace: {
                                            ...gridInfo.leftRightSpace,
                                            visible: false,
                                        },
                                    });
                                }}
                            />
                        ) : (
                            <IconFont
                                name="InvisibleBold"
                                onClick={() => {
                                    setGridInfo({
                                        ...gridInfo,
                                        leftRightSpace: {
                                            ...gridInfo.leftRightSpace,
                                            visible: true,
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>

                    <div className="row">
                        <div className="title">上下间距：</div>
                        <div className="input">
                            <InputNumber
                                value={gridInfo.topBottomSpace.value}
                                onChange={(value) => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        topBottomSpace: {
                                            ...gridInfo.topBottomSpace,
                                            value: value || 0,
                                        },
                                    });
                                }}
                            />
                        </div>
                        {gridInfo.topBottomSpace.visible ? (
                            <IconFont
                                name="VisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        topBottomSpace: {
                                            ...gridInfo.topBottomSpace,
                                            visible: false,
                                        },
                                    });
                                }}
                            />
                        ) : (
                            <IconFont
                                name="InvisibleBold"
                                onClick={() => {
                                    gridInfoChange({
                                        ...gridInfo,
                                        topBottomSpace: {
                                            ...gridInfo.topBottomSpace,
                                            visible: true,
                                        },
                                    });
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Popover content={Content}>
            <div className="c-grid-line-operate">
                <IconFont name="ReferenceLineBold" />
                <span>布局网格</span>
            </div>
        </Popover>
    );
};

export default GridLineOperate;
